import { useEffect, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import DashboardLayout from "../../layouts/DashboardLayout";
import "./QRScannerr.css";
import { markAttendance } from "../../services/attendanceService";
import { FaMobileAlt } from "react-icons/fa";
import { collection, getDocs, query, where } from "firebase/firestore";

import { db, auth } from "../../firebase/config";

export default function QRScanner() {
  const [scanResult, setScanResult] = useState("");

  useEffect(() => {
    let scanner;

    const verifyMember = async (memberId, qrGymId) => {
      const currentGymId = auth.currentUser?.uid;

      if (!currentGymId) {
        throw new Error("Gym owner is not authenticated.");
      }

      // VERY IMPORTANT:
      // QR belongs to another gym
      if (qrGymId !== currentGymId) {
        throw new Error("This QR code belongs to another gym.");
      }

      const membersRef = collection(db, "gyms", currentGymId, "members");

      const q = query(membersRef, where("memberId", "==", memberId));

      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        throw new Error("Member does not belong to this gym.");
      }

      const memberDoc = snapshot.docs[0];

      return {
        id: memberDoc.id,
        ...memberDoc.data(),
      };
    };

    const startScanner = () => {
      const readerElement = document.getElementById("reader");

      if (!readerElement) {
        console.error("Reader element not found");
        return;
      }

      scanner = new Html5QrcodeScanner(
        "reader",
        {
          qrbox: {
            width: 250,
            height: 250,
          },
          fps: 5,
        },
        false,
      );

      // scanner.render(
      //   async (decodedText) => {
      //     try {
      //       setScanResult(decodedText);

      //       const data = JSON.parse(decodedText);

      //       // await markAttendance({
      //       //   memberName: data.name,
      //       //   date: new Date().toISOString().split("T")[0],
      //       //   status: "Present",
      //       // });

      //       await markAttendance({
      //         memberId: data.memberId,
      //         memberName: data.name,
      //         date: new Date().toISOString().split("T")[0],
      //         status: "Present",
      //       });

      //       alert(`${data.name} Attendance Marked`);
      //     } catch (error) {
      //       console.error(error);
      //       alert("Invalid QR Code");
      //     }
      //   },
      //   (error) => {
      //     console.log(error);
      //   },
      // );
      scanner.render(
        async (decodedText) => {
          try {
            const data = JSON.parse(decodedText);

            console.log("QR DATA:", data);

            // ==========================================
            // VALIDATE QR DATA
            // ==========================================

            if (!data.gymId || !data.memberId) {
              throw new Error("Invalid member QR code.");
            }

            // ==========================================
            // VERIFY MEMBER + GYM
            // ==========================================

            const member = await verifyMember(data.memberId, data.gymId);

            console.log("VERIFIED MEMBER:", member);

            // ==========================================
            // CHECK MEMBERSHIP EXPIRY
            // ==========================================

            if (!member.expiryDate) {
              throw new Error("Member expiry date is not available.");
            }

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const expiryDate = new Date(member.expiryDate);
            expiryDate.setHours(0, 0, 0, 0);

            console.log("Today:", today);
            console.log("Expiry:", expiryDate);

            // Membership is valid ON the expiry date.
            // It becomes expired from the next day.

            if (expiryDate < today) {
              alert(
                `Membership Expired!\n\n` +
                  `Member: ${member.fullName}\n` +
                  `Member ID: ${member.memberId}\n` +
                  `Expiry Date: ${member.expiryDate}`,
              );

              return;
            }

            // ==========================================
            // MEMBERSHIP ACTIVE
            // NOW MARK ATTENDANCE
            // ==========================================

            const result = await markAttendance({
              memberId: member.memberId,
              memberName: member.fullName,
              status: "Present",
            });

            // ==========================================
            // ALREADY MARKED TODAY
            // ==========================================

            if (result.alreadyMarked) {
              alert(
                `${member.fullName}'s attendance is already marked for today.`,
              );

              return;
            }

            // ==========================================
            // SUCCESS
            // ==========================================

            setScanResult(decodedText);

            alert(`${member.fullName} Attendance Marked Successfully`);
          } catch (error) {
            console.error("QR ATTENDANCE ERROR:", error);

            alert(
              error.message ||
                "Invalid QR code or member does not belong to this gym.",
            );
          }
        },

        (error) => {
          console.log("QR SCANNER ERROR:", error);
        },
      );
    };

    const timer = setTimeout(startScanner, 500);

    return () => {
      clearTimeout(timer);

      if (scanner) {
        scanner.clear().catch(() => {});
      }
    };
  }, []);

  return (
    <DashboardLayout>
      <div className="qr-page">
        <div className="qr-header">
          <h1>QR Attendance Scanner</h1>

          <p style={{ fontWeight: "bold", color: "white" }}>
            Scan member QR codes for quick attendance tracking.
          </p>
        </div>

        <div className="qr-card">
          <div className="qr-icon">
            <FaMobileAlt />
          </div>

          <h2>Scan QR Code</h2>

          <p className="qr-subtitle">
            Position the QR code inside the scanner frame.
          </p>

          <div id="reader"></div>

          {scanResult && (
            <div className="scan-result">
              <h3>Scan Successful</h3>

              <p>{scanResult}</p>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}
